<div class="gallery__item border-radius">
  <a
    [routerLink]="
      more ? 'dreambox' : galleryItem.id ? '/item/' + galleryItem.id : null
    "
  >
    <img
      [src]="galleryItem.thumbnail.url"
      [width]="galleryItem.thumbnail.width"
      [height]="galleryItem.thumbnail.height"
      [alt]="galleryItem.name"
      class="gallery__image"
    />
    @if (more) {
      <div class="gallery__more">
        <div>
          <strong>{{ more }}</strong>
          <span>more videos</span>
        </div>
      </div>
    } @else {
      <div class="gallery__info">
        <div>
          <div class="gallery__heading heading heading_small">
            {{ galleryItem.name }}
          </div>
          <div class="gallery__sizes">
            @for (size of galleryItem.details; track $index) {
              <div class="content-type">
                {{ size.type }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </a>
  @if (!more) {
    @if (isAuthenticated$ | async) {
      <app-is-favorite
        linkClass="gallery__fav"
        [imageId]="galleryItem.id"
        [isFavorite]="galleryItem.is_favorite"
      />
    }
  }
</div>
